<template>
	<div class="dashboard-container">
		<div class="app-container">
			<el-card>
				<div class="fr">
					<el-button type="primary" size="mini" icon="el-icon-plus" @click="handlAdd">新增员工</el-button>
				</div>
			</el-card>
			<el-card shadow="never" class="boxMar">
				<el-table :data="tableData" style="width: 100%">
					<el-table-column type="index" width="50">
					</el-table-column>
					<el-table-column prop="create_time" label="日期" width="180">
					</el-table-column>
					<el-table-column prop="name" label="姓名" width="180">
					</el-table-column>
					<el-table-column prop="mobile" label="手机号" width="180">
					</el-table-column>
					<el-table-column prop="mobile" label="操作" width="180">
						<template slot-scope="scope">
							<el-button size="mini" @click="handedit(scope.row)">编辑</el-button>
							<el-button type="danger" size="mini" @click="handdel(scope.row)">删除</el-button>
						</template>
					</el-table-column>
				</el-table>
				<page :page="page" :size="size" :total="total" @current-change="handleChangePage"></page>
			</el-card>
		</div>

		<el-dialog title="新增员工" :inline="true" :visible.sync="dialogVisible" width="50%" :before-close="handleClose">
			<el-form :label-position="labelPosition" label-width="80px" :model="form" :rules="rules" ref="form">
				<el-form-item label="姓名" prop="name">
					<el-input v-model="form.name"></el-input>
				</el-form-item>
				<el-form-item label="手机" prop="mobile">
					<el-input v-model="form.mobile"></el-input>
				</el-form-item>
			</el-form>
			<span slot="footer" class="dialog-footer">
				<el-button @click="dialogVisible = false">取 消</el-button>
				<el-button type="primary" @click="submit">确 定</el-button>
			</span>
		</el-dialog>

	</div>
</template>
<script>
	import Page from '../../components/page/page.vue'
	import {
		useradd,
		userlist
	} from '../../api/user.js'
	export default {
		components: {
			Page
		},
		data() {
			return {
				dialogVisible: false,
				labelPosition: 'right',
				total:0,
				page:1,
				size:10,
				form: {
					name: '',
					mobile: ''
				},
				rules: {
					name: [{
						required: true,
						message: '请输入姓名',
						trigger: 'blur'
					}],
					mobile: [{
						required: true,
						message: '请输入手机号',
						trigger: 'blur'
					}]
				},
				tableData: [],
			}
		},
		mounted() {
			this.getuserlist()
		},
		methods: {
			handleChangePage(val){
				this.page = val
				this.getuserlist()
			},
			getuserlist() {
				userlist({page:this.page,limit:this.size}).then(res => {
					console.log(res);
					this.tableData = res.data
					this.total = res.total
				})
			},
			handedit(row) {
				console.log(row);
			},
			handdel(row) {
				console.log(row);
			},
			handlAdd() {
				this.dialogVisible = true
			},
			submit() {
				this.$refs.form.validate((valid) => {
					console.log(valid);
					if (valid) {
						//提交
						useradd(this.form).then(res => {
							if (res.code == 1) {
								this.$message({
									message: res.msg,
									type: 'success'
								});
							}
						})
						this.handleClose()
					}
				})
			},
			handleClose() {
				this.$refs.form.resetFields()
				this.dialogVisible = false
			},
			cancel() {
				this.handleClose()
			}
		}
	}
</script>


<style lang="less" scoped>
	.iconInfo {
		.fa {
			color: #999;
			font-size: 14px;
			cursor: pointer;
		}

		a {
			padding: 0 5px;
		}
	}

	.serachInput {
		.el-input--medium {
			width: 150px;

			.el-input__inner {}
		}
	}

	.serachInput .el-input--medium .el-input__inner {
		height: 26px;
		line-height: 26px;
	}
</style>
